var React = require('react');

function VoEiendom60px (props) {
    return React.createElement("symbol",props,React.createElement("path",{"d":"M59.473 33.663a.992.992 0 0 1-1.408-.07l-4.155-4.595v28.901c0 1.101-.982 1.985-2.081 1.985H7.988c-1.098 0-2.078-.884-2.078-1.985V28.995l-4.158 4.598a.998.998 0 1 1-1.477-1.341L5.91 26.02v-.121c0-.386.267-.513.613-.557L29.17.298c.378-.417 1.1-.417 1.477 0l22.647 25.044c.347.044.616.17.616.557v.124l5.633 6.229a1.001 1.001 0 0 1-.07 1.411zm-7.563-6.877L29.909 2.456 7.902 26.792c.003.036.008.075.008.107v31h44V26.786zm-27.98 1.145c2.55 0 4.762 1.427 5.979 3.529 1.216-2.102 3.428-3.529 5.978-3.529 3.845 0 6.975 3.211 6.975 7.156 0 1.845-.817 3.789-2.184 5.201l-10.093 9.346c-.06.055-.131.086-.199.124-.035.019-.065.048-.102.063a.998.998 0 0 1-.375.077.994.994 0 0 1-.375-.077c-.037-.015-.067-.044-.103-.063-.068-.038-.139-.069-.199-.124l-10.054-9.308c-1.406-1.45-2.223-3.394-2.223-5.239 0-3.945 3.13-7.156 6.975-7.156zm-3.36 10.967l9.339 8.643 9.378-8.681c.961-.995 1.582-2.455 1.582-3.773 0-2.844-2.235-5.16-4.982-5.16-2.747 0-4.982 2.316-4.982 5.16 0 .552-.446 1-.996 1a.998.998 0 0 1-.997-1c0-2.844-2.235-5.16-4.982-5.16-2.747 0-4.982 2.316-4.982 5.16 0 1.318.621 2.778 1.622 3.811z"}));
}

VoEiendom60px.displayName = "VoEiendom60px";

VoEiendom60px.defaultProps = {"preserveAspectRatio":"xMidYMid","viewBox":"0 0 59.82 59.9"};

module.exports = VoEiendom60px;

VoEiendom60px.default = VoEiendom60px;



//////////////////
// WEBPACK FOOTER
// ./data/assets/sprites/60px/vo-eiendom-60px.svg
// module id = 1224
// module chunks = 0